export const en = {
    email: 'E-mail',
    password: 'Password',
    login_btn: 'Login',
    search_placeholder: 'search item...',
};